import { CommonModule, DOCUMENT, isPlatformBrowser } from '@angular/common'
import { Component, DestroyRef, Inject, inject, OnInit } from '@angular/core'
import { MatButtonModule } from '@angular/material/button'
import { MatButtonToggleModule } from '@angular/material/button-toggle'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatInputModule } from '@angular/material/input'
import { MatTabsModule } from '@angular/material/tabs'
import { HotelRepository } from '@core/services/repositories/hotel.repository'

@Component({
  selector: 'iho-residency',
  templateUrl: './residency.component.html',
  styleUrls: ['./residency.component.scss'],
  standalone: true,
  providers: [HotelRepository],
  imports: [
    CommonModule,
    MatInputModule,
    MatTabsModule,
    MatFormFieldModule,
    MatButtonModule,
    MatButtonToggleModule,
    
]
})

export class ResidencyComponent implements OnInit {
  listBreadcrumb: any;
    hotelRepo = inject(HotelRepository)
    data:any;
  constructor( ) {
  }
  ngOnInit(): void {
    this.listBreadcrumb = [
      {
        "@id": "/",
        "name": "رزرو هتل"
      },
      {
        "@id": "#",
        "name": "هتل های زنجیره ای"
      }
    ]
    this.getDataResidency();
  
}
getDataResidency(){
  this.hotelRepo.getSectionChainHotels()
    .subscribe(
      (response) => {
        this.data = response.Chains;
      }
    )
}


}
